import { useQuery } from "react-query";


import { getCompanies } from "../../../../../MyApi/hr/companies";
import { getBranches } from "../../../../../MyApi/sb/branches";
import { getContracts } from "../../../../../MyApi/hr/contracts";

import LoadingSpinner from "../../../../UI/spinner";
import icons from "../../../../../Data/icons";

import classes from "./addPayrolls.module.css";
import { getEmployes } from "../../../../../MyApi/sb/employes";




const AddPayrolls = ({
  undeserved_amount , setUndeservedAmount , setDeservedAmount, setExtraAmount, setDiscountAmont,setLoanAmount, setHrContractId, setStatus,  setBranchId,    setAuto,  setCompanyId, setDate, setDescription ,description ,auto ,date ,setEmployId
  
}) => {
const compainesQuery = useQuery("getComapines" , getCompanies)
const branchesQuery =useQuery("getBranches", getBranches)
const contractQuery= useQuery("getContarcts", getContracts)
const employeQuery = useQuery("getEmploy",getEmployes)
  
  const compaines = compainesQuery.data?.data
  const branches = branchesQuery.data?.data
  const contracts=  contractQuery.data?.data
  const employes =employeQuery.data?.data

  const DescriptionIcon = icons.description
  const LevelIcon = icons.levels
  const Company = icons.company
  const handleEmployId =(e)=>{
    setEmployId(e.target.options[e.target.selectedIndex].id)
  }
  const handleDeservedAmountChange = (e) => {
    setDeservedAmount(e.target.value);
  };
  const handleunDeservedAmountChange =(e)=>{
    setUndeservedAmount(e.target.value)
  }
  const handleDateChange =(e)=>{
    setDate(e.target.value)
  }
  const handleCompanyIdChange = (e) => {
    setCompanyId(e.target.options[e.target.selectedIndex].id);  
  }; 
  const handleExtraAmount =(e)=>{
    setExtraAmount(+e.target.value)
  }
  const handleDiscountAmount =(e)=>{
    setDiscountAmont(+e.target.value)
  }
  const handleLoanAmount =(e)=>{
    setLoanAmount(+e.target.value)
  }
  const handleBranchIdChange =(e)=>{
    setBranchId(e.target.options[e.target.selectedIndex].id)
  }
  const handleConstractId =(e)=>{
    setHrContractId(e.target.options[e.target.selectedIndex].id)
  }
  const handleDescChange =(e)=>{
  setDescription(e.target.value)
  }
  const handleStatus =(e)=>{
    setStatus(e.target.value)
  }
  const handleAutoChange = (e)=>{
    const isChecked = e.target.checked
   setAuto(isChecked ? 1 :0)
  }

  if(compainesQuery.isLoading || branchesQuery.isLoading){
    return <LoadingSpinner/>
  }
  const statuses = [
    "pending","approved","deserved","paid"
  ]

  return (
    <div className={classes.formCard}>
      <h5 className={classes.headTitle}>معلومات دفتر المرتبات</h5>

      <div className={classes.formGrid}>
      <div className={classes.formCol}>
          <label htmlFor=""> 
           التاريخ</label>
          <div className={classes.iconInput}>
            <LevelIcon />
          </div>
          <input
            type="date"
            placeholder="ادخل التاريخ  "
            onChange={handleDateChange}
            value={date}
            className={classes.inputCustom}
          />
              
        </div>
        <div className={classes.formCol}>
          <label htmlFor=""> 
          المبلغ المستحق</label>
          <div className={classes.iconInput}>
            <LevelIcon />
          </div>
          <input
            type="number"
            placeholder="ادخل  
المبلغ المستحق"
            onChange={handleDeservedAmountChange}
           
            className={classes.inputCustom}
          />
              
        </div>
        <div className={classes.formCol}>
          <label htmlFor=""> 
          المبلغ  غير المستحق </label>
          <div className={classes.iconInput}>
            <LevelIcon />
          </div>
          <input
            type="number"
            placeholder="ادخل  
المبلغ غير  المستحق"
            onChange={handleunDeservedAmountChange}
            
            className={classes.inputCustom}
          />
              
        </div>
        <div className={classes.formCol}>
          <label htmlFor=""> 
          المبلغ   الاضافي </label>
          <div className={classes.iconInput}>
            <LevelIcon />
          </div>
          <input
            type="number"
            placeholder="ادخل  
المبلغ الاضافي"
            onChange={handleExtraAmount}
         
            className={classes.inputCustom}
          />
              
        </div>
        <div className={classes.formCol}>
          <label htmlFor=""> 
             مقدار الخصم </label>
          <div className={classes.iconInput}>
            <LevelIcon />
          </div>
          <input
            type="number"
            placeholder="ادخل  
مقدار  الخصم"
            onChange={handleDiscountAmount}
         
            className={classes.inputCustom}
          />
              
        </div>
        <div className={classes.formCol}>
          <label htmlFor=""> 
              
مبلغ القرض </label>
          <div className={classes.iconInput}>
            <LevelIcon />
          </div>
          <input
            type="number"
            placeholder="ادخل  
مبلغ القرض"
            onChange={handleLoanAmount}
         
            className={classes.inputCustom}
          />
              
        </div>
         <div className={classes.formCol}>
          <label htmlFor="">الوصف </label>
          <div className={classes.iconInput}>
            <DescriptionIcon />
          </div>
          <textarea  
            type="textarea"
            placeholder="ادخل  الوصف"
            onChange={handleDescChange}
            value={description}
            className={classes.inputCustom}
          > </textarea> 
        </div>

        {!employeQuery.data ? <div>no data available </div> :  
        <div className={classes.formCol}>
          <label htmlFor=""> الموظف</label>
          <div className={classes.iconInput}>
            <Company />
          </div>
          <select
            type="text"
            placeholder="اختار الموظف  "
            onChange={handleEmployId}
            className={classes.inputCustom}
          >
            <option  value="">اختار الموظف </option>
           { employes.map((employ)=>(
            <option key={employ.id}    id={employ.id} value={employ.name_en} >{employ.name_en}</option>
           ))}
         </select>
        </div> }
        
          {!compainesQuery.data ? <div>no data available </div> :  
        <div className={classes.formCol}>
          <label htmlFor=""> الشركة</label>
          <div className={classes.iconInput}>
            <Company />
          </div>
          <select
            type="text"
            placeholder="اختار الشركة  "
            onChange={handleCompanyIdChange}
            className={classes.inputCustom}
          >
            <option  selected>اختار الشركة </option>
           { compaines.map((company)=>(
            <option key={company.id}    id={company.id} value={company.name} >{company.name}</option>
           ))}
         </select>
        </div> }
    
        {!branchesQuery.data ? <div>no data available </div> :  
        <div className={classes.formCol}>
          <label htmlFor=""> الفرع</label>
          <div className={classes.iconInput}>
            <Company />
          </div>
          <select
            type="text"
      
            placeholder="اختار الفرع  "
            onChange={handleBranchIdChange}
            className={classes.inputCustom}
          >
            <option  selected>اختار الفرع </option>
           { branches.map((branch)=>(
            <option key={branch.id}    id={branch.id} value={branch.name} >{branch.name}</option>
           ))}
         </select>
        </div> }

        {!contractQuery.data ? <div>no data available </div> :  
        <div className={classes.formCol}>
          <label htmlFor=""> العقود</label>
          <div className={classes.iconInput}>
            <Company />
          </div>
          <select
            type="text"
      
            placeholder="اختار العقد  "
            onChange={handleConstractId}
            className={classes.inputCustom}
          >
            <option  selected>اختار العقد </option>
           { contracts.map((contract)=>(
            <option key={contract.id}    id={contract.id} value={contract.company} >{contract.company}</option>
           ))}
         </select>
        </div> }

        <div className={classes.formCol}>
          <label htmlFor=""> 
              الحالة </label>
          <div className={classes.iconInput}>
            <LevelIcon />
          </div>
          <select
            type="number"
            placeholder="ادخل الحالة "
            onChange={handleStatus}
         
            className={classes.inputCustom}
          >
            <option value=""></option>
          {statuses.map((status ,i)=>(
            <option key={i}  value={status}>{status}</option>
          ))  }
            
             </select>
              
        </div>
   
        
          <div className={classes.formCol}> 
           <label htmlFor="" className={auto ? `${classes.active}` : `${classes.disActive}`}> {auto===1 ?" آلي":"غير آلي"} </label>
         
          <label class="switch">
           <input type="checkbox" onChange={handleAutoChange} checked={auto}/>
             <span class="slider round"></span>
         </label>   
        </div>
   
      
     
      </div>
    </div>
  );
};

export default AddPayrolls;
